
interface InitialData {
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export default class ProjectDocumentData {
  id: number;
  url: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  name: string;
  imageUrl: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };

  constructor(entity: InitialData) {
    this.id = entity.id;
    this.url = typeof entity.url === 'object' ? entity.url : { url: entity.url };
    this.imageUrl = typeof entity.imageUrl === 'object' ? entity.imageUrl : { url: entity.imageUrl };
    this.name = entity.name;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/ProjectDocumentData.tsx